import { cmsAxiosInstance } from '../configuration/axiosConfig';
import { ClientResponse } from '../model/ClientResponse';
import BoxListItemType from '../module/BoxList/BoxListItemType';

const mapToVybranePredpisy = (responseItem): BoxListItemType => (
  {
    id: responseItem['@id'],
    to: responseItem.link,
    description: responseItem.text,
    name: responseItem.label,
  }
);

export const getVybranePredpisyList = async ():
  Promise<ClientResponse<Array<BoxListItemType>>> => {
  const {
    data,
    status,
  } = await cmsAxiosInstance.get(
    '/vybrane-predpisy/@nodes',
  );

  return {
    data: data.map(responseItem => mapToVybranePredpisy(responseItem)),
    responseCode: status,
  };
};
